// src/utils/printUtils.js

const UNIVERSITY_LOGO_URL = "/logo-rmbg.png"; // place UG logo in public folder
const UNIVERSITY_NAME = "University of Ghana Alumni Association Liberia";
const SYSTEM_NAME = "Alumni Database Management System";

/* Format date for printed reports */
function formatPrintedOnDate() {
  const now = new Date();

  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  return now.toLocaleString("en-US", options);
}

/* Main print function */
export function printTableWithHeader({ title, summary, columns, rows }) {
  const printWindow = window.open("", "_blank", "width=900,height=700");

  if (!printWindow) {
    alert("Popup blocked. Please allow popups for this site.");
    return;
  }

  const printedOn = formatPrintedOnDate();
  const sourceURL = window.location.href;

  const tableHeader = columns.map((col) => `<th>${col.label}</th>`).join("");

  const tableBody = rows
    .map(
      (row) => `
        <tr>
          ${columns.map((col) => `<td>${row[col.key] ?? ""}</td>`).join("")}
        </tr>
      `
    )
    .join("");

  printWindow.document.write(`
    <html>
      <head>
        <title>${title}</title>
        <style>

          body {
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
            padding: 40px;
            color: #153D6F;
          }

          .header {
            text-align: center;
            margin-bottom: 30px;
          }

          .header img {
            height: 80px;
            margin-bottom: 10px;
          }

          .university-name {
            font-size: 26px;
            font-weight: bold;
            color: #153D6F;
          }

          .system-name {
            font-size: 18px;
            font-weight: 600;
            color: #403C3A;
          }

          .print-title {
            font-size: 22px;
            margin-top: 10px;
            font-weight: bold;
            color: #153D6F;
          }

          .summary {
            text-align: center;
            font-size: 15px;
            margin-top: 6px;
            margin-bottom: 10px;
            font-weight: 600;
            color: #403C3A;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 25px;
          }

          th, td {
            border: 1px solid #ddd;
            padding: 10px 8px;
            text-align: left;
          }

          th {
            background-color: #153D6F;
            color: white;
            font-weight: 600;
          }

          tr:nth-child(even) {
            background-color: #f8f8f8;
          }

          .print-footer {
            margin-top: 35px;
            font-size: 12px;
            color: #403C3A;
            text-align: right;
          }

          .source-url {
            font-size: 12px;
            color: #9D9C9B;
            text-align: right;
            margin-top: 4px;
          }

          .divider {
            height: 2px;
            background-color: #B79A64;
            margin: 15px 0 25px 0;
          }

          @media print {
            body {
              zoom: 85%;
            }
          }

        </style>
      </head>

      <body>

        <div class="header">
          <img src="${UNIVERSITY_LOGO_URL}" alt="University Logo" />

          <div class="university-name">${UNIVERSITY_NAME}</div>
          <div class="system-name">${SYSTEM_NAME}</div>

          <div class="divider"></div>

          <div class="print-title">${title}</div>

          ${summary ? `<div class="summary">${summary}</div>` : ""}
        </div>

        <table>
          <thead>
            <tr>
              ${tableHeader}
            </tr>
          </thead>

          <tbody>
            ${tableBody}
          </tbody>
        </table>

        <div class="print-footer">
          Printed on: ${printedOn}
        </div>

        <div class="source-url">
          ${sourceURL}
        </div>

        <script>
          window.onload = function () {
            window.print();
            window.onafterprint = function () {
              window.close();
            };
          };
        </script>

      </body>
    </html>
  `);

  printWindow.document.close();
}